import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=512a848f&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512a848f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('512a848f')) {
      api.createRecord('512a848f', component.options)
    } else {
      api.reload('512a848f', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=512a848f&scoped=true&", function () {
      api.rerender('512a848f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oTD4RQ9Q1UWQ/JS/comp/Accordion.vue"
export default component.exports